module.exports = __webpack_public_path__ + "static/media/mobileban4.9bd54df4.jpg";